import React, { useState, useCallback, Fragment, useEffect } from "react";
import LoginForm from "../../../forms/authentication/Login.form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ValidationSchema, InitialData } from "../../../conf/login";
import { yupResolver } from "@hookform/resolvers/yup";
import { clearError, login } from "../../../store/user.store";
import { Loading } from "../../../components/common";
import CardFormComponent from "components/common/card/CardForm.component";
import { openSnackbar } from "store/slices/snackbar";
import WrapperSliderCard from "components/common/card/WrapperSliderCard.component";
import { useTranslation } from "react-i18next";
import {Box, Grid} from "@mui/material";

const LoginContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    error: errorApi,
    token,
    user,
  } = useSelector((state) => state.user);
  const [isSubmitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const { handleSubmit, control, formState } = useForm({
    resolver: yupResolver(ValidationSchema),
    defaultValues: InitialData,
  });

  const onSubmit = useCallback((values) => {
    dispatch(login(values));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (token && user) {
      setSubmitting(false);
      navigate("/dashboard/home");
    }
    // eslint-disable-next-line
  }, [token, user]);

  useEffect(() => {
    if (errorApi) {
      setError(errorApi);
      dispatch(clearError());
    }
    // eslint-disable-next-line
  }, [errorApi]);

  useEffect(() => {
    if (!loading) {
      if (error?.response?.status === 403) {
        setError(null);
        navigate("/resend-confirm");
      } else {
        if (error) {
          dispatch(
            openSnackbar({
              open: true,
              message: error?.response?.data?.message
                ? error.response.data?.message
                : "Errore",
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
          setError(null);
        }
      }
    }
    // eslint-disable-next-line
  }, [loading, error]);

  return (
    <Fragment>
      {loading && <Loading />}

      <WrapperSliderCard>
        <CardFormComponent
          title={t("Welcome")}
          subTitle={t("Enter your credentials to continue")}
          labelButton="Login"
        >

          {/*FIXME: ONLY FOR DEMO*/}
          <Grid item mb={2}>
            <Box sx={{ fontWeight: "bold", textAlign: "center" }}>
              Email: demo@widata.cloud
            </Box>
            <Box  sx={{ fontWeight: "bold", textAlign: "center" }}>
              Password: demo@explore
            </Box>
          </Grid>

          <LoginForm
            errors={formState.errors}
            control={control}
            isSubmitting={isSubmitting}
            handleSubmit={handleSubmit(onSubmit)}
          />

        </CardFormComponent>
      </WrapperSliderCard>
    </Fragment>
  );
};

export default LoginContainer;
